/**
 * Formats distance number to delimetered string
 */
export function formatDistance(distance: number): string {
    if (distance === null || distance === undefined) {
        return '-';
    }
    return distance.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
}
